module.exports = function() {
  return new Worker(__webpack_public_path__ + "34d0379c98a74e1aa202.worker.js");
};